import { ChevronRight, ClipboardList } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useSetupTasks } from "@/hooks/useSetupTasks";

/**
 * Tarjeta discreta del Panel (19-sep-2026, petición de Luis): aviso FIJO de
 * lo que le falta al negocio por configurar (dirección, foto, página web...).
 * A diferencia del popup flotante (`SetupAssistantPopup.tsx`), que deja de
 * insistir tras el tercer "Más tarde", esta tarjeta sigue enseñando TODAS
 * las tareas pendientes -incluidas las que el cliente descartó en el
 * flotante- para que pueda terminar cuando quiera. Desaparece sola en cuanto
 * `hechas === total`.
 */
export default function SetupTasksCard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin" || user?.role === "owner";

  const { data } = useSetupTasks(isAdmin);

  // Sin datos (endpoint aún no desplegado, falló, o no aplica al rol): no se
  // pinta nada, nunca un error.
  if (!isAdmin || !data) return null;

  const { hechas, total, tareas } = data;
  if (total === 0 || hechas >= total) return null;

  const pendientes = tareas.filter((t) => !t.hecha);
  if (pendientes.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 md:p-5">
      <div className="flex items-center gap-2.5 mb-3">
        <div className="p-1.5 bg-primary-50 rounded-lg flex-shrink-0">
          <ClipboardList className="w-4 h-4 text-primary-600" />
        </div>
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-gray-900">
            Termina de configurar tu negocio
          </h3>
          <p className="text-xs text-gray-500">
            {hechas} de {total} listo
          </p>
        </div>
      </div>
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden mb-1">
        <div
          className="h-full bg-primary-500 rounded-full transition-all duration-500"
          style={{ width: `${(hechas / total) * 100}%` }}
        />
      </div>
      <ul className="divide-y divide-gray-100">
        {pendientes.map((t) => (
          <li key={t.id}>
            <button
              type="button"
              onClick={() => navigate(t.ctaRuta)}
              className="w-full flex items-center justify-between gap-2 py-2.5 text-left group"
            >
              <span className="text-sm text-gray-700 group-hover:text-primary-700 min-w-0 truncate">
                {t.titulo}
              </span>
              <ChevronRight className="w-4 h-4 text-gray-300 group-hover:text-primary-500 flex-shrink-0" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
